import TemplateGroupModal, { MODAL_STATES } from './TemplateGroupModal'

export default TemplateGroupModal
export { MODAL_STATES }
